// GENERATED by scripts/build-icons.mjs from icons/minus.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Minus = createIcon('minus', [
  ['path', { d: "M5 12h14" }],
])
